/* eslint-disable no-console */
declare const APP_NAME: string;
declare const APP_VERSION: string;
declare const UI_COMPONENT_VERSION: string;

/**
 * Questa funzione utilizza delle variabili che vengono iniettate da webpack tramite il plugin di DefinePlugin.
 *
 * per farlo funzionare è necessario includere nel file `config-override.js` le seguenti righe:
 * @example
 * ```
 * config.plugins.push(new webpack.DefinePlugin({
 *   APP_NAME: `"${packageJson.name} - ${packageJson.description}"`,
 *   APP_VERSION: `"${packageJson.version}"`,
 *   UI_COMPONENT_VERSION: `"${packageJson.dependencies["@gsd/ui-components"]}"`
 * }));
 * console.log(config.plugins);
 * ```
 * @param window oggetto da estendere che conterrà la funzione `appInfo()`
 */
export function enableAppInfo(window: any) {
  window.appInfo = () => {
    const appName = APP_NAME;
    const appVersion = APP_VERSION;
    const uiComponentVersion = UI_COMPONENT_VERSION;
    console.group("Application info");
    console.log("%cGSD Sistemi e Servizi", "color:#fa5d4b;font-weight:bold;font-size:20px");
    if (appName) console.log("%cApplication Name:", "color:lightgreen" , appName);
    if (appVersion) console.log("%cApplication Version:", "color:lightgreen", appVersion);
    if (uiComponentVersion) {
      console.group("%cShared UI Components Version:", "color:lightgreen");
      console.table(uiComponentVersion);
      console.groupEnd();
    }
    console.groupEnd();
  };
  window.addEventListener("devtoolschange", (args: CustomEvent<typeof devtools>) => {
    if (args.detail.isOpen) setTimeout(window.appInfo);
  });

  main({ emitEvents: false });
  setInterval(main, 500);
}


const devtools = {
  isOpen: false,
  orientation: undefined as "vertical" | "horizontal" | undefined,
};

const threshold = 170;

const emitEvent = (isOpen: boolean, orientation: "vertical" | "horizontal" | undefined) => {
  globalThis.dispatchEvent(new globalThis.CustomEvent("devtoolschange", {
    detail: {
      isOpen,
      orientation,
    },
  }));
};

const main = ({ emitEvents = true } = {}) => {
  const widthThreshold = globalThis.outerWidth - globalThis.innerWidth > threshold;
  const heightThreshold = globalThis.outerHeight - globalThis.innerHeight > threshold;
  const orientation = widthThreshold ? "vertical" : "horizontal";

  if (
    !(heightThreshold && widthThreshold)
		&& (((globalThis as any).Firebug?.chrome?.isInitialized) || widthThreshold || heightThreshold)
  ) {
    if ((!devtools.isOpen || devtools.orientation !== orientation) && emitEvents) {
      emitEvent(true, orientation);
    }

    devtools.isOpen = true;
    devtools.orientation = orientation;
  } else {
    if (devtools.isOpen && emitEvents) {
      emitEvent(false, undefined);
    }

    devtools.isOpen = false;
    devtools.orientation = undefined;
  }
};
